import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { eventService } from '../services/eventService';
import { registrationService } from '../services/registrationService';
import { toast } from 'react-toastify';
import { format } from 'date-fns';
import 'react-quill/dist/quill.snow.css';
import './PublicRegistration.css';

const PublicRegistration = () => {
  const { token } = useParams();
  const [event, setEvent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);
  const [countryCode, setCountryCode] = useState('+55');
  const [phoneDigits, setPhoneDigits] = useState('');
  const [phoneDisplay, setPhoneDisplay] = useState('');
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    accept_messages: true
  });

  const countryOptions = [
    { code: '+93', label: 'Afeganistão (+93)' },
    { code: '+355', label: 'Albânia (+355)' },
    { code: '+49', label: 'Alemanha (+49)' },
    { code: '+376', label: 'Andorra (+376)' },
    { code: '+244', label: 'Angola (+244)' },
    { code: '+1', label: 'Antígua e Barbuda (+1)' },
    { code: '+966', label: 'Arábia Saudita (+966)' },
    { code: '+213', label: 'Argélia (+213)' },
    { code: '+54', label: 'Argentina (+54)' },
    { code: '+374', label: 'Armênia (+374)' },
    { code: '+61', label: 'Austrália (+61)' },
    { code: '+43', label: 'Áustria (+43)' },
    { code: '+994', label: 'Azerbaijão (+994)' },
    { code: '+1', label: 'Bahamas (+1)' },
    { code: '+880', label: 'Bangladesh (+880)' },
    { code: '+1', label: 'Barbados (+1)' },
    { code: '+973', label: 'Bahrein (+973)' },
    { code: '+32', label: 'Bélgica (+32)' },
    { code: '+501', label: 'Belize (+501)' },
    { code: '+229', label: 'Benin (+229)' },
    { code: '+375', label: 'Bielorrússia (+375)' },
    { code: '+591', label: 'Bolívia (+591)' },
    { code: '+387', label: 'Bósnia e Herzegovina (+387)' },
    { code: '+267', label: 'Botsuana (+267)' },
    { code: '+55', label: 'Brasil (+55)' },
    { code: '+673', label: 'Brunei (+673)' },
    { code: '+359', label: 'Bulgária (+359)' },
    { code: '+226', label: 'Burkina Faso (+226)' },
    { code: '+257', label: 'Burundi (+257)' },
    { code: '+975', label: 'Butão (+975)' },
    { code: '+238', label: 'Cabo Verde (+238)' },
    { code: '+237', label: 'Camarões (+237)' },
    { code: '+855', label: 'Camboja (+855)' },
    { code: '+1', label: 'Canadá (+1)' },
    { code: '+974', label: 'Catar (+974)' },
    { code: '+7', label: 'Cazaquistão (+7)' },
    { code: '+235', label: 'Chade (+235)' },
    { code: '+56', label: 'Chile (+56)' },
    { code: '+86', label: 'China (+86)' },
    { code: '+357', label: 'Chipre (+357)' },
    { code: '+57', label: 'Colômbia (+57)' },
    { code: '+269', label: 'Comores (+269)' },
    { code: '+242', label: 'Congo (+242)' },
    { code: '+850', label: 'Coreia do Norte (+850)' },
    { code: '+82', label: 'Coreia do Sul (+82)' },
    { code: '+225', label: 'Costa do Marfim (+225)' },
    { code: '+506', label: 'Costa Rica (+506)' },
    { code: '+385', label: 'Croácia (+385)' },
    { code: '+53', label: 'Cuba (+53)' },
    { code: '+45', label: 'Dinamarca (+45)' },
    { code: '+253', label: 'Djibuti (+253)' },
    { code: '+1', label: 'Dominica (+1)' },
    { code: '+20', label: 'Egito (+20)' },
    { code: '+503', label: 'El Salvador (+503)' },
    { code: '+971', label: 'Emirados Árabes Unidos (+971)' },
    { code: '+593', label: 'Equador (+593)' },
    { code: '+291', label: 'Eritreia (+291)' },
    { code: '+421', label: 'Eslováquia (+421)' },
    { code: '+386', label: 'Eslovênia (+386)' },
    { code: '+34', label: 'Espanha (+34)' },
    { code: '+1', label: 'Estados Unidos (+1)' },
    { code: '+372', label: 'Estônia (+372)' },
    { code: '+268', label: 'Eswatini (+268)' },
    { code: '+251', label: 'Etiópia (+251)' },
    { code: '+679', label: 'Fiji (+679)' },
    { code: '+63', label: 'Filipinas (+63)' },
    { code: '+358', label: 'Finlândia (+358)' },
    { code: '+33', label: 'França (+33)' },
    { code: '+241', label: 'Gabão (+241)' },
    { code: '+220', label: 'Gâmbia (+220)' },
    { code: '+233', label: 'Gana (+233)' },
    { code: '+995', label: 'Geórgia (+995)' },
    { code: '+1', label: 'Granada (+1)' },
    { code: '+30', label: 'Grécia (+30)' },
    { code: '+502', label: 'Guatemala (+502)' },
    { code: '+592', label: 'Guiana (+592)' },
    { code: '+224', label: 'Guiné (+224)' },
    { code: '+245', label: 'Guiné-Bissau (+245)' },
    { code: '+240', label: 'Guiné Equatorial (+240)' },
    { code: '+509', label: 'Haiti (+509)' },
    { code: '+504', label: 'Honduras (+504)' },
    { code: '+36', label: 'Hungria (+36)' },
    { code: '+967', label: 'Iêmen (+967)' },
    { code: '+91', label: 'Índia (+91)' },
    { code: '+62', label: 'Indonésia (+62)' },
    { code: '+964', label: 'Iraque (+964)' },
    { code: '+98', label: 'Irã (+98)' },
    { code: '+353', label: 'Irlanda (+353)' },
    { code: '+354', label: 'Islândia (+354)' },
    { code: '+972', label: 'Israel (+972)' },
    { code: '+39', label: 'Itália (+39)' },
    { code: '+1', label: 'Jamaica (+1)' },
    { code: '+81', label: 'Japão (+81)' },
    { code: '+962', label: 'Jordânia (+962)' },
    { code: '+383', label: 'Kosovo (+383)' },
    { code: '+965', label: 'Kuwait (+965)' },
    { code: '+856', label: 'Laos (+856)' },
    { code: '+266', label: 'Lesoto (+266)' },
    { code: '+371', label: 'Letônia (+371)' },
    { code: '+961', label: 'Líbano (+961)' },
    { code: '+231', label: 'Libéria (+231)' },
    { code: '+218', label: 'Líbia (+218)' },
    { code: '+423', label: 'Liechtenstein (+423)' },
    { code: '+370', label: 'Lituânia (+370)' },
    { code: '+352', label: 'Luxemburgo (+352)' },
    { code: '+389', label: 'Macedônia do Norte (+389)' },
    { code: '+261', label: 'Madagascar (+261)' },
    { code: '+60', label: 'Malásia (+60)' },
    { code: '+265', label: 'Malawi (+265)' },
    { code: '+960', label: 'Maldivas (+960)' },
    { code: '+223', label: 'Mali (+223)' },
    { code: '+356', label: 'Malta (+356)' },
    { code: '+212', label: 'Marrocos (+212)' },
    { code: '+230', label: 'Maurícia (+230)' },
    { code: '+222', label: 'Mauritânia (+222)' },
    { code: '+52', label: 'México (+52)' },
    { code: '+95', label: 'Mianmar (+95)' },
    { code: '+691', label: 'Micronésia (+691)' },
    { code: '+258', label: 'Moçambique (+258)' },
    { code: '+373', label: 'Moldova (+373)' },
    { code: '+377', label: 'Mônaco (+377)' },
    { code: '+976', label: 'Mongólia (+976)' },
    { code: '+382', label: 'Montenegro (+382)' },
    { code: '+264', label: 'Namíbia (+264)' },
    { code: '+674', label: 'Nauru (+674)' },
    { code: '+977', label: 'Nepal (+977)' },
    { code: '+505', label: 'Nicarágua (+505)' },
    { code: '+227', label: 'Níger (+227)' },
    { code: '+234', label: 'Nigéria (+234)' },
    { code: '+47', label: 'Noruega (+47)' },
    { code: '+64', label: 'Nova Zelândia (+64)' },
    { code: '+968', label: 'Omã (+968)' },
    { code: '+31', label: 'Países Baixos (+31)' },
    { code: '+680', label: 'Palau (+680)' },
    { code: '+507', label: 'Panamá (+507)' },
    { code: '+675', label: 'Papua-Nova Guiné (+675)' },
    { code: '+92', label: 'Paquistão (+92)' },
    { code: '+595', label: 'Paraguai (+595)' },
    { code: '+51', label: 'Peru (+51)' },
    { code: '+48', label: 'Polônia (+48)' },
    { code: '+351', label: 'Portugal (+351)' },
    { code: '+254', label: 'Quênia (+254)' },
    { code: '+996', label: 'Quirguistão (+996)' },
    { code: '+44', label: 'Reino Unido (+44)' },
    { code: '+236', label: 'República Centro-Africana (+236)' },
    { code: '+243', label: 'República Democrática do Congo (+243)' },
    { code: '+1', label: 'República Dominicana (+1)' },
    { code: '+420', label: 'República Tcheca (+420)' },
    { code: '+40', label: 'Romênia (+40)' },
    { code: '+250', label: 'Ruanda (+250)' },
    { code: '+7', label: 'Rússia (+7)' },
    { code: '+677', label: 'Ilhas Salomão (+677)' },
    { code: '+685', label: 'Samoa (+685)' },
    { code: '+1', label: 'Santa Lúcia (+1)' },
    { code: '+1', label: 'São Cristóvão e Nevis (+1)' },
    { code: '+378', label: 'San Marino (+378)' },
    { code: '+1', label: 'São Vicente e Granadinas (+1)' },
    { code: '+239', label: 'São Tomé e Príncipe (+239)' },
    { code: '+221', label: 'Senegal (+221)' },
    { code: '+232', label: 'Serra Leoa (+232)' },
    { code: '+381', label: 'Sérvia (+381)' },
    { code: '+248', label: 'Seychelles (+248)' },
    { code: '+65', label: 'Singapura (+65)' },
    { code: '+963', label: 'Síria (+963)' },
    { code: '+252', label: 'Somália (+252)' },
    { code: '+94', label: 'Sri Lanka (+94)' },
    { code: '+268', label: 'Suazilândia (+268)' },
    { code: '+249', label: 'Sudão (+249)' },
    { code: '+211', label: 'Sudão do Sul (+211)' },
    { code: '+46', label: 'Suécia (+46)' },
    { code: '+41', label: 'Suíça (+41)' },
    { code: '+597', label: 'Suriname (+597)' },
    { code: '+66', label: 'Tailândia (+66)' },
    { code: '+886', label: 'Taiwan (+886)' },
    { code: '+992', label: 'Tajiquistão (+992)' },
    { code: '+255', label: 'Tanzânia (+255)' },
    { code: '+670', label: 'Timor-Leste (+670)' },
    { code: '+228', label: 'Togo (+228)' },
    { code: '+676', label: 'Tonga (+676)' },
    { code: '+1', label: 'Trinidad e Tobago (+1)' },
    { code: '+216', label: 'Tunísia (+216)' },
    { code: '+993', label: 'Turcomenistão (+993)' },
    { code: '+90', label: 'Turquia (+90)' },
    { code: '+688', label: 'Tuvalu (+688)' },
    { code: '+380', label: 'Ucrânia (+380)' },
    { code: '+256', label: 'Uganda (+256)' },
    { code: '+598', label: 'Uruguai (+598)' },
    { code: '+998', label: 'Uzbequistão (+998)' },
    { code: '+678', label: 'Vanuatu (+678)' },
    { code: '+39', label: 'Vaticano (+39)' },
    { code: '+58', label: 'Venezuela (+58)' },
    { code: '+84', label: 'Vietnã (+84)' },
    { code: '+260', label: 'Zâmbia (+260)' },
    { code: '+263', label: 'Zimbábue (+263)' }
  ];

  useEffect(() => {
    loadEvent();
  }, [token]);

  const loadEvent = async () => {
    try {
      const data = await eventService.getByShareToken(token);
      setEvent(data.event);
    } catch (error) {
      toast.error('Evento não encontrado');
    } finally {
      setLoading(false);
    }
  };

  const getEmbedUrl = (url) => {
    if (!url) return null;
    
    // Se já for um link de embed, retorna
    if (url.includes('/embed')) return url;
    
    // Tenta extrair coordenadas de diferentes formatos do Google Maps
    const patterns = [
      // Formato: https://www.google.com/maps/@-15.6863489,-48.2622184,17.6z
      /google\.com\/maps\/@(-?\d+\.\d+),(-?\d+\.\d+)/,
      // Formato antigo
      /maps\.google\.com.*@(-?\d+\.\d+),(-?\d+\.\d+)/
    ];
    
    for (const pattern of patterns) {
      const match = url.match(pattern);
      if (match && match[1] && match[2]) {
        // Se encontrou coordenadas, cria URL de embed
        return `https://maps.google.com/maps?q=${match[1]},${match[2]}&z=15&output=embed`;
      }
    }
    
    // Para links curtos ou outros formatos não suportados, retorna null
    if (url.includes('goo.gl') || url.includes('maps.app.goo.gl')) {
      return null;
    }
    
    return null;
  };

  const handleChange = (e) => {
    const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
    setFormData({ ...formData, [e.target.name]: value });
  };

  const formatPhone = (digits, code) => {
    if (code === '+55') {
      const part1 = digits.slice(0, 2);
      const part2 = digits.slice(2, 7);
      const part3 = digits.slice(7, 11);
      if (digits.length > 7) return `(${part1}) ${part2}-${part3}`.trim();
      if (digits.length > 2) return `(${part1}) ${part2}`.trim();
      if (digits.length > 0) return `(${part1}`;
      return '';
    }
    return digits.replace(/(.{3})/g, '$1 ').trim();
  };

  const handlePhoneChange = (e) => {
    const digits = e.target.value.replace(/\D/g, '').slice(0, 15);
    setPhoneDigits(digits);
    const formatted = formatPhone(digits, countryCode);
    setPhoneDisplay(formatted);
    setFormData((prev) => ({ ...prev, phone: `${countryCode}${digits}` }));
  };

  const handleCountryChange = (e) => {
    const code = e.target.value;
    setCountryCode(code);
    const formatted = formatPhone(phoneDigits, code);
    setPhoneDisplay(formatted);
    setFormData((prev) => ({ ...prev, phone: `${code}${phoneDigits}` }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    try {
      await registrationService.create(event.id, formData);
      setSuccess(true);
      toast.success('Inscrição realizada com sucesso!');
    } catch (error) {
      const errorMessage = error.response?.data?.error || 'Erro ao realizar inscrição';
      
      // Tratamento específico para telefone duplicado
      if (errorMessage.includes('telefone já está inscrito')) {
        toast.error('⚠️ Este número de telefone já está inscrito neste evento!', {
          autoClose: 5000,
          style: {
            fontSize: '1rem',
            fontWeight: '500'
          }
        });
      } else {
        toast.error(errorMessage);
      }
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) {
    return (
      <div className="loading">
        <div className="spinner"></div>
      </div>
    );
  }

  if (!event) {
    return (
      <div className="public-container">
        <div className="public-card">
          <h2>Evento não encontrado</h2>
        </div>
      </div>
    );
  }

  if (success) {
    return (
      <div className="public-container">
        <div className="public-card">
          <div className="success-message">
            <h2>🎉 Inscrição Confirmada!</h2>
            <p>Você foi inscrito com sucesso no evento:</p>
            <h3>{event.title}</h3>
            <p>📅 {format(new Date(event.start_date), "dd/MM/yyyy 'às' HH:mm")}</p>
            <p>📍 {event.location}</p>
            {event.locationLink && (
              <div style={{ margin: '1.5rem 0' }}>
                {getEmbedUrl(event.locationLink) ? (
                  <>
                    <iframe
                      src={getEmbedUrl(event.locationLink)}
                      width="100%"
                      height="300"
                      style={{ border: '0', borderRadius: '8px', marginBottom: '1rem' }}
                      allowFullScreen
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                      title="Localização do evento"
                    />
                    <a 
                      href={event.locationLink} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '0.5rem',
                        padding: '0.75rem 1.5rem',
                        backgroundColor: '#4285f4',
                        color: 'white',
                        textDecoration: 'none',
                        borderRadius: '8px',
                        fontWeight: '500',
                        fontSize: '0.875rem',
                        transition: 'background-color 0.2s'
                      }}
                      onMouseOver={(e) => e.target.style.backgroundColor = '#3367d6'}
                      onMouseOut={(e) => e.target.style.backgroundColor = '#4285f4'}
                    >
                      🗺️ Abrir no Google Maps
                    </a>
                  </>
                ) : (
                  <a 
                    href={event.locationLink} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: '0.5rem',
                      padding: '0.75rem 1.5rem',
                      backgroundColor: '#4285f4',
                      color: 'white',
                      textDecoration: 'none',
                      borderRadius: '8px',
                      fontWeight: '500',
                      fontSize: '1rem',
                      transition: 'background-color 0.2s'
                    }}
                    onMouseOver={(e) => e.target.style.backgroundColor = '#3367d6'}
                    onMouseOut={(e) => e.target.style.backgroundColor = '#4285f4'}
                  >
                    🗺️ Ver Localização no Mapa
                  </a>
                )}
              </div>
            )}
            {formData.accept_messages && (
              <p style={{ marginTop: '1rem', color: 'var(--text-light)' }}>
                Você receberá lembretes sobre o evento via WhatsApp
              </p>
            )}
          </div>
        </div>
      </div>
    );
  }

  if (event.is_full) {
    return (
      <div className="public-container">
        <div className="public-card">
          {event.image_url && (
            <div className="public-image" style={{ opacity: 0.6 }}>
              <img
                src={`${process.env.REACT_APP_API_URL?.replace('/api', '')}${event.image_url}`}
                alt={event.title}
              />
            </div>
          )}
          
          <div style={{ 
            textAlign: 'center', 
            padding: '3rem 2rem',
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            borderRadius: '12px',
            color: 'white',
            margin: '2rem 0'
          }}>
            <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>😔</div>
            <h2 style={{ 
              fontSize: '2rem', 
              marginBottom: '1rem',
              color: 'white',
              fontWeight: 'bold'
            }}>
              Evento Lotado
            </h2>
            <p style={{ 
              fontSize: '1.1rem', 
              marginBottom: '1.5rem',
              color: 'rgba(255, 255, 255, 0.95)',
              lineHeight: '1.6'
            }}>
              Infelizmente todas as vagas para este evento foram preenchidas.
            </p>
            
            <div style={{
              backgroundColor: 'rgba(255, 255, 255, 0.2)',
              borderRadius: '8px',
              padding: '1.5rem',
              marginTop: '2rem',
              backdropFilter: 'blur(10px)'
            }}>
              <h3 style={{ 
                fontSize: '1.5rem',
                marginBottom: '1rem',
                color: 'white'
              }}>
                {event.title}
              </h3>
              <div style={{ 
                fontSize: '1rem',
                color: 'rgba(255, 255, 255, 0.9)',
                marginBottom: '0.5rem'
              }}>
                📅 {format(new Date(event.start_date), "dd/MM/yyyy 'às' HH:mm")}
              </div>
              <div style={{ 
                fontSize: '1rem',
                color: 'rgba(255, 255, 255, 0.9)'
              }}>
                📍 {event.location}
              </div>
              {event.max_attendees && (
                <div style={{ 
                  fontSize: '1rem',
                  color: 'rgba(255, 255, 255, 0.9)',
                  marginTop: '0.5rem',
                  fontWeight: '500'
                }}>
                  👥 {event.registrations_count} / {event.max_attendees} inscritos
                </div>
              )}
            </div>
            
            <p style={{ 
              marginTop: '2rem',
              fontSize: '0.95rem',
              color: 'rgba(255, 255, 255, 0.85)',
              fontStyle: 'italic'
            }}>
              Fique atento aos próximos eventos! 🎉
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="public-container">
      <div className="public-card">
        {event.image_url && (
          <div className="public-image">
            <img
              src={`${process.env.REACT_APP_API_URL?.replace('/api', '')}${event.image_url}`}
              alt={event.title}
            />
          </div>
        )}

        <div className="public-content">
          <h1>{event.title}</h1>
          
          <div className="event-info">
            <p>📅 {format(new Date(event.start_date), "dd/MM/yyyy 'às' HH:mm")}</p>
            <p>⏱️ Duração: {event.duration_days} {event.duration_days === 1 ? 'dia' : 'dias'}</p>
            <p>📍 {event.location}</p>
            {event.max_attendees && (
              <p>👥 {event.registrations_count} / {event.max_attendees} inscritos</p>
            )}
          </div>

          {event.locationLink && (
            <div style={{ margin: '1.5rem 0' }}>
              {getEmbedUrl(event.locationLink) ? (
                <>
                  <iframe
                    src={getEmbedUrl(event.locationLink)}
                    width="100%"
                    height="300"
                    style={{ border: '0', borderRadius: '8px', marginBottom: '1rem' }}
                    allowFullScreen
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="Localização do evento"
                  />
                  <a 
                    href={event.locationLink} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: '0.5rem',
                      padding: '0.75rem 1.5rem',
                      backgroundColor: '#4285f4',
                      color: 'white',
                      textDecoration: 'none',
                      borderRadius: '8px',
                      fontWeight: '500',
                      fontSize: '0.875rem',
                      transition: 'background-color 0.2s'
                    }}
                    onMouseOver={(e) => e.target.style.backgroundColor = '#3367d6'}
                    onMouseOut={(e) => e.target.style.backgroundColor = '#4285f4'}
                  >
                    🗺️ Abrir no Google Maps
                  </a>
                </>
              ) : (
                <a 
                  href={event.locationLink} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '0.5rem',
                    padding: '0.75rem 1.5rem',
                    backgroundColor: '#4285f4',
                    color: 'white',
                    textDecoration: 'none',
                    borderRadius: '8px',
                    fontWeight: '500',
                    fontSize: '1rem',
                    transition: 'background-color 0.2s'
                  }}
                  onMouseOver={(e) => e.target.style.backgroundColor = '#3367d6'}
                  onMouseOut={(e) => e.target.style.backgroundColor = '#4285f4'}
                >
                  🗺️ Ver Localização no Mapa
                </a>
              )}
            </div>
          )}

          <div
            className="event-description ql-editor"
            dangerouslySetInnerHTML={{ __html: event.description }}
          />

          <form onSubmit={handleSubmit} className="registration-form">
            <h2>Fazer Inscrição</h2>

            <div className="form-group">
              <label className="form-label">Nome completo *</label>
              <input
                type="text"
                name="name"
                className="form-input"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label className="form-label">Telefone (WhatsApp) *</label>
              <div className="phone-row">
                <select
                  className="form-select country-select"
                  value={countryCode}
                  onChange={handleCountryChange}
                >
                  {countryOptions.map((opt) => (
                    <option key={opt.code} value={opt.code}>{opt.label}</option>
                  ))}
                </select>
                <input
                  type="tel"
                  name="phone"
                  className="form-input"
                  value={phoneDisplay}
                  onChange={handlePhoneChange}
                  placeholder="(11) 99999-9999"
                  required
                />
              </div>
              <small className="hint">O número será salvo com o código do país.</small>
            </div>

            <div className="form-group">
              <label className="form-label">Email (opcional)</label>
              <input
                type="email"
                name="email"
                className="form-input"
                value={formData.email}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label className="checkbox-label">
                <input
                  type="checkbox"
                  name="accept_messages"
                  checked={formData.accept_messages}
                  onChange={handleChange}
                />
                <span>Aceito receber lembretes sobre o evento via WhatsApp</span>
              </label>
            </div>

            <button type="submit" className="btn btn-primary btn-block" disabled={submitting}>
              {submitting ? 'Inscrevendo...' : 'Confirmar Inscrição'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default PublicRegistration;
